import { render } from "./AlzataTabs.vue?vue&type=template&id=40458a47"
import script from "./AlzataTabs.vue?vue&type=script&lang=js"
export * from "./AlzataTabs.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__